export function validateRequest(value) {
  const validate = (function () {
    'use strict'
    const hasOwn = Function.prototype.call.bind(Object.prototype.hasOwnProperty)
    const format0 = new RegExp(
      '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$',
      'i',
    )
    const pattern0 = new RegExp('^.*$', 'u')
    const ref1 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 1) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        if (!(typeof data[0] === 'boolean')) {
          validate.errors = [
            { keywordLocation: '#/0/type', instanceLocation: '#/0' },
          ]
          return false
        }
      }
      if (data.length > 1) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const errorMerge = (
      { keywordLocation, instanceLocation },
      schemaBase,
      dataBase,
    ) => ({
      keywordLocation: `${schemaBase}${keywordLocation.slice(1)}`,
      instanceLocation: `${dataBase}${instanceLocation.slice(1)}`,
    })
    const stringLength = (string) =>
      /[\uD800-\uDFFF]/.test(string) ? [...string].length : string.length
    const format1 = (input) =>
      input.length % 4 === 0 && /^[a-z0-9+/]*={0,3}$/i.test(input)
    const ref4 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'string')) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 1 || stringLength(data) < 1) {
        validate.errors = [
          { keywordLocation: '#/minLength', instanceLocation: '#' },
        ]
        return false
      }
      if (!format1(data)) {
        validate.errors = [
          { keywordLocation: '#/format', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref3 = function validate(data) {
      validate.errors = null
      const err1 = validate.errors
      const res1 = ref4(data)
      const suberr1 = ref4.errors
      validate.errors = err1
      if (!res1) {
        validate.errors = [errorMerge(suberr1[0], '#/$ref', '#')]
        return false
      }
      if (data.length > 17080 && stringLength(data) > 17080) {
        validate.errors = [
          { keywordLocation: '#/maxLength', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref2 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 1) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        const err2 = validate.errors
        const res2 = ref3(data[0])
        const suberr2 = ref3.errors
        validate.errors = err2
        if (!res2) {
          validate.errors = [errorMerge(suberr2[0], '#/0/$ref', '#/0')]
          return false
        }
      }
      if (data.length > 1) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref5 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 1) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        if (!Array.isArray(data[0])) {
          validate.errors = [
            { keywordLocation: '#/0/type', instanceLocation: '#/0' },
          ]
          return false
        }
        if (data[0].length < 1) {
          validate.errors = [
            { keywordLocation: '#/0/minItems', instanceLocation: '#/0' },
          ]
          return false
        }
        for (let i = 0; i < data[0].length; i++) {
          if (i in data[0] && hasOwn(data[0], i)) {
            const err4 = validate.errors
            const res4 = ref3(data[0][i])
            const suberr4 = ref3.errors
            validate.errors = err4
            if (!res4) {
              validate.errors = [
                errorMerge(suberr4[0], '#/0/items/$ref', '#/' + i),
              ]
              return false
            }
          }
        }
      }
      if (data.length > 1) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref8 = function validate(data) {
      validate.errors = null
      if (
        !(
          data === 'processed' ||
          data === 'confirmed' ||
          data === 'finalized' ||
          data === 'recent' ||
          data === 'single' ||
          data === 'singleGossip' ||
          data === 'root' ||
          data === 'max'
        )
      ) {
        validate.errors = [{ keywordLocation: '#/enum', instanceLocation: '#' }]
        return false
      }
      return true
    }
    const ref7 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if ('maxRetries' in data && hasOwn(data, 'maxRetries')) {
        if (!Number.isInteger(data.maxRetries)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/maxRetries/type',
              instanceLocation: '#/maxRetries',
            },
          ]
          return false
        }
        if (!(0 <= data.maxRetries)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/maxRetries/minimum',
              instanceLocation: '#/maxRetries',
            },
          ]
          return false
        }
      }
      if ('minContextSlot' in data && hasOwn(data, 'minContextSlot')) {
        if (!Number.isInteger(data.minContextSlot)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/minContextSlot/type',
              instanceLocation: '#/minContextSlot',
            },
          ]
          return false
        }
        if (!(0 <= data.minContextSlot)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/minContextSlot/minimum',
              instanceLocation: '#/minContextSlot',
            },
          ]
          return false
        }
      }
      if (
        'preflightCommitment' in data &&
        hasOwn(data, 'preflightCommitment')
      ) {
        const err7 = validate.errors
        const res7 = ref8(data.preflightCommitment)
        const suberr7 = ref8.errors
        validate.errors = err7
        if (!res7) {
          validate.errors = [
            errorMerge(
              suberr7[0],
              '#/properties/preflightCommitment/$ref',
              '#/preflightCommitment',
            ),
          ]
          return false
        }
      }
      if ('skipPreflight' in data && hasOwn(data, 'skipPreflight')) {
        if (!(typeof data.skipPreflight === 'boolean')) {
          validate.errors = [
            {
              keywordLocation: '#/properties/skipPreflight/type',
              instanceLocation: '#/skipPreflight',
            },
          ]
          return false
        }
      }
      for (const key0 of Object.keys(data)) {
        if (
          key0 !== 'maxRetries' &&
          key0 !== 'minContextSlot' &&
          key0 !== 'preflightCommitment' &&
          key0 !== 'skipPreflight'
        )
          delete data[key0]
      }
      return true
    }
    const ref6 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 2) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        const err6 = validate.errors
        const res6 = ref3(data[0])
        const suberr6 = ref3.errors
        validate.errors = err6
        if (!res6) {
          validate.errors = [errorMerge(suberr6[0], '#/0/$ref', '#/0')]
          return false
        }
      }
      if (1 in data && hasOwn(data, 1)) {
        let passes1 = 0
        const sub2 = (() => {
          if (!(data[1] === null)) return false
          return true
        })()
        if (sub2) passes1++
        const sub3 = (() => {
          const err8 = validate.errors
          const res8 = ref7(data[1])
          const suberr8 = ref7.errors
          validate.errors = err8
          if (!res8) return false
          return true
        })()
        if (sub3) passes1++
        if (passes1 !== 1) {
          validate.errors = [
            { keywordLocation: '#/1/oneOf', instanceLocation: '#/1' },
          ]
          return false
        }
      }
      if (data.length > 2) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref10 = function validate(data) {
      validate.errors = null
      const err10 = validate.errors
      const res10 = ref4(data)
      const suberr10 = ref4.errors
      validate.errors = err10
      if (!res10) {
        validate.errors = [errorMerge(suberr10[0], '#/$ref', '#')]
        return false
      }
      return true
    }
    const ref11 = function validate(data) {
      validate.errors = null
      if (!(data === 'hex' || data === 'utf8')) {
        validate.errors = [{ keywordLocation: '#/enum', instanceLocation: '#' }]
        return false
      }
      return true
    }
    const ref9 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 2) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        const err11 = validate.errors
        const res11 = ref10(data[0])
        const suberr11 = ref10.errors
        validate.errors = err11
        if (!res11) {
          validate.errors = [errorMerge(suberr11[0], '#/0/$ref', '#/0')]
          return false
        }
      }
      if (1 in data && hasOwn(data, 1)) {
        const err12 = validate.errors
        const res12 = ref11(data[1])
        const suberr12 = ref11.errors
        validate.errors = err12
        if (!res12) {
          validate.errors = [errorMerge(suberr12[0], '#/1/$ref', '#/1')]
          return false
        }
      }
      if (data.length > 2) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref12 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length > 1) {
        validate.errors = [
          { keywordLocation: '#/maxItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        const err14 = validate.errors
        const res14 = ref8(data[0])
        const suberr14 = ref8.errors
        validate.errors = err14
        if (!res14) {
          validate.errors = [errorMerge(suberr14[0], '#/0/$ref', '#/0')]
          return false
        }
      }
      if (data.length > 1) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const format2 = new RegExp('^(?!_)(\\n|\\r|.)*$', '')
    const format3 = new RegExp(
      "^[a-z][a-z0-9+\\-.]*:(?:\\/?\\/(?:(?:[a-z0-9\\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d\\d?)\\.){3}(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d\\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|v[0-9a-f]+\\.[a-z0-9\\-._~!$&'()*+,;=:]+)\\]|(?:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d\\d?)\\.){3}(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d\\d?)|(?:[a-z0-9\\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\\d*)?(?:\\/(?:[a-z0-9\\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\\/?(?:(?:[a-z0-9\\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\\/(?:[a-z0-9\\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?)(?:\\?(?:[a-z0-9\\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$",
      'i',
    )
    const pointerPart = (s) =>
      /~\//.test(s) ? `${s}`.replace(/~/g, '~0').replace(/\//g, '~1') : s
    const ref13 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 2) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        if (!(typeof data[0] === 'boolean')) {
          validate.errors = [
            { keywordLocation: '#/0/type', instanceLocation: '#/0' },
          ]
          return false
        }
      }
      if (1 in data && hasOwn(data, 1)) {
        if (
          !(typeof data[1] === 'object' && data[1] && !Array.isArray(data[1]))
        ) {
          validate.errors = [
            { keywordLocation: '#/1/type', instanceLocation: '#/1' },
          ]
          return false
        }
        if (!('isVerified' in data[1] && hasOwn(data[1], 'isVerified'))) {
          validate.errors = [
            {
              keywordLocation: '#/1/required',
              instanceLocation: '#/1/isVerified',
            },
          ]
          return false
        }
        if ('name' in data[1] && hasOwn(data[1], 'name')) {
          if (!(typeof data[1].name === 'string')) {
            validate.errors = [
              {
                keywordLocation: '#/1/properties/name/type',
                instanceLocation: '#/1/name',
              },
            ]
            return false
          }
          if (
            data[1].name.length > 10000 &&
            stringLength(data[1].name) > 10000
          ) {
            validate.errors = [
              {
                keywordLocation: '#/1/properties/name/maxLength',
                instanceLocation: '#/1/name',
              },
            ]
            return false
          }
          if (!format2.test(data[1].name)) {
            validate.errors = [
              {
                keywordLocation: '#/1/properties/name/format',
                instanceLocation: '#/1/name',
              },
            ]
            return false
          }
        }
        if ('origin' in data[1] && hasOwn(data[1], 'origin')) {
          if (!(typeof data[1].origin === 'string')) {
            validate.errors = [
              {
                keywordLocation: '#/1/properties/origin/type',
                instanceLocation: '#/1/origin',
              },
            ]
            return false
          }
          if (!format3.test(data[1].origin)) {
            validate.errors = [
              {
                keywordLocation: '#/1/properties/origin/format',
                instanceLocation: '#/1/origin',
              },
            ]
            return false
          }
        }
        if ('icon' in data[1] && hasOwn(data[1], 'icon')) {
          if (!(typeof data[1].icon === 'string')) {
            validate.errors = [
              {
                keywordLocation: '#/1/properties/icon/type',
                instanceLocation: '#/1/icon',
              },
            ]
            return false
          }
          if (
            data[1].icon.length > 10000 &&
            stringLength(data[1].icon) > 10000
          ) {
            validate.errors = [
              {
                keywordLocation: '#/1/properties/icon/maxLength',
                instanceLocation: '#/1/icon',
              },
            ]
            return false
          }
          if (!format2.test(data[1].icon)) {
            validate.errors = [
              {
                keywordLocation: '#/1/properties/icon/format',
                instanceLocation: '#/1/icon',
              },
            ]
            return false
          }
        }
        if ('cluster' in data[1] && hasOwn(data[1], 'cluster')) {
          if (!(typeof data[1].cluster === 'string')) {
            validate.errors = [
              {
                keywordLocation: '#/1/properties/cluster/type',
                instanceLocation: '#/1/cluster',
              },
            ]
            return false
          }
          if (
            !(
              data[1].cluster === 'mainnet-beta' ||
              data[1].cluster === 'testnet' ||
              data[1].cluster === 'devnet'
            )
          ) {
            validate.errors = [
              {
                keywordLocation: '#/1/properties/cluster/enum',
                instanceLocation: '#/1/cluster',
              },
            ]
            return false
          }
        }
        if (!(typeof data[1].isVerified === 'boolean')) {
          validate.errors = [
            {
              keywordLocation: '#/1/properties/isVerified/type',
              instanceLocation: '#/1/isVerified',
            },
          ]
          return false
        }
        for (const key1 of Object.keys(data[1])) {
          if (
            key1 !== 'name' &&
            key1 !== 'origin' &&
            key1 !== 'icon' &&
            key1 !== 'cluster' &&
            key1 !== 'isVerified'
          ) {
            validate.errors = [
              {
                keywordLocation: '#/1/additionalProperties',
                instanceLocation: '#/1/' + pointerPart(key1),
              },
            ]
            return false
          }
        }
      }
      if (data.length > 2) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const pattern1 = new RegExp('^[1-9A-Za-z][^OIl]{32,44}$', 'u')
    const ref15 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (
        !('authorizedPublicKey' in data && hasOwn(data, 'authorizedPublicKey'))
      ) {
        validate.errors = [
          {
            keywordLocation: '#/required',
            instanceLocation: '#/authorizedPublicKey',
          },
        ]
        return false
      }
      if (!(typeof data.authorizedPublicKey === 'string')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/authorizedPublicKey/type',
            instanceLocation: '#/authorizedPublicKey',
          },
        ]
        return false
      }
      if (
        data.authorizedPublicKey.length > 44 &&
        stringLength(data.authorizedPublicKey) > 44
      ) {
        validate.errors = [
          {
            keywordLocation: '#/properties/authorizedPublicKey/maxLength',
            instanceLocation: '#/authorizedPublicKey',
          },
        ]
        return false
      }
      if (
        data.authorizedPublicKey.length < 32 ||
        stringLength(data.authorizedPublicKey) < 32
      ) {
        validate.errors = [
          {
            keywordLocation: '#/properties/authorizedPublicKey/minLength',
            instanceLocation: '#/authorizedPublicKey',
          },
        ]
        return false
      }
      if (!pattern1.test(data.authorizedPublicKey)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/authorizedPublicKey/pattern',
            instanceLocation: '#/authorizedPublicKey',
          },
        ]
        return false
      }
      for (const key2 of Object.keys(data)) {
        if (key2 !== 'authorizedPublicKey') {
          validate.errors = [
            {
              keywordLocation: '#/additionalProperties',
              instanceLocation: '#/' + pointerPart(key2),
            },
          ]
          return false
        }
      }
      return true
    }
    const ref14 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 2) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        if (!Array.isArray(data[0])) {
          validate.errors = [
            { keywordLocation: '#/0/type', instanceLocation: '#/0' },
          ]
          return false
        }
        if (data[0].length < 1) {
          validate.errors = [
            { keywordLocation: '#/0/minItems', instanceLocation: '#/0' },
          ]
          return false
        }
        for (let j = 0; j < data[0].length; j++) {
          if (j in data[0] && hasOwn(data[0], j)) {
            const err17 = validate.errors
            const res17 = ref3(data[0][j])
            const suberr17 = ref3.errors
            validate.errors = err17
            if (!res17) {
              validate.errors = [
                errorMerge(suberr17[0], '#/0/items/$ref', '#/' + j),
              ]
              return false
            }
          }
        }
      }
      if (1 in data && hasOwn(data, 1)) {
        const err18 = validate.errors
        const res18 = ref15(data[1])
        const suberr18 = ref15.errors
        validate.errors = err18
        if (!res18) {
          validate.errors = [errorMerge(suberr18[0], '#/1/$ref', '#/1')]
          return false
        }
      }
      if (data.length > 2) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref17 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if ('minContextSlot' in data && hasOwn(data, 'minContextSlot')) {
        if (!Number.isInteger(data.minContextSlot)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/minContextSlot/type',
              instanceLocation: '#/minContextSlot',
            },
          ]
          return false
        }
        if (!(0 <= data.minContextSlot)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/minContextSlot/minimum',
              instanceLocation: '#/minContextSlot',
            },
          ]
          return false
        }
      }
      for (const key3 of Object.keys(data)) {
        if (key3 !== 'minContextSlot') {
          validate.errors = [
            {
              keywordLocation: '#/additionalProperties',
              instanceLocation: '#/' + pointerPart(key3),
            },
          ]
          return false
        }
      }
      return true
    }
    const ref16 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 2) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        if (!Array.isArray(data[0])) {
          validate.errors = [
            { keywordLocation: '#/0/type', instanceLocation: '#/0' },
          ]
          return false
        }
        if (data[0].length < 1) {
          validate.errors = [
            { keywordLocation: '#/0/minItems', instanceLocation: '#/0' },
          ]
          return false
        }
        for (let k = 0; k < data[0].length; k++) {
          if (k in data[0] && hasOwn(data[0], k)) {
            const err20 = validate.errors
            const res20 = ref3(data[0][k])
            const suberr20 = ref3.errors
            validate.errors = err20
            if (!res20) {
              validate.errors = [
                errorMerge(suberr20[0], '#/0/items/$ref', '#/' + k),
              ]
              return false
            }
          }
        }
      }
      if (1 in data && hasOwn(data, 1)) {
        const err21 = validate.errors
        const res21 = ref15(data[1])
        const suberr21 = ref15.errors
        validate.errors = err21
        if (!res21) {
          validate.errors = [errorMerge(suberr21[0], '#/1/$ref', '#/1')]
          return false
        }
      }
      if (2 in data && hasOwn(data, 2)) {
        const err22 = validate.errors
        const res22 = ref17(data[2])
        const suberr22 = ref17.errors
        validate.errors = err22
        if (!res22) {
          validate.errors = [errorMerge(suberr22[0], '#/2/$ref', '#/2')]
          return false
        }
      }
      if (data.length > 3) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref18 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 2) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        if (!Array.isArray(data[0])) {
          validate.errors = [
            { keywordLocation: '#/0/type', instanceLocation: '#/0' },
          ]
          return false
        }
        if (data[0].length < 1) {
          validate.errors = [
            { keywordLocation: '#/0/minItems', instanceLocation: '#/0' },
          ]
          return false
        }
        for (let l = 0; l < data[0].length; l++) {
          if (l in data[0] && hasOwn(data[0], l)) {
            const err24 = validate.errors
            const res24 = ref10(data[0][l])
            const suberr24 = ref10.errors
            validate.errors = err24
            if (!res24) {
              validate.errors = [
                errorMerge(suberr24[0], '#/0/items/$ref', '#/' + l),
              ]
              return false
            }
          }
        }
      }
      if (1 in data && hasOwn(data, 1)) {
        const err25 = validate.errors
        const res25 = ref15(data[1])
        const suberr25 = ref15.errors
        validate.errors = err25
        if (!res25) {
          validate.errors = [errorMerge(suberr25[0], '#/1/$ref', '#/1')]
          return false
        }
      }
      if (data.length > 2) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref0 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('jsonrpc' in data && hasOwn(data, 'jsonrpc'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/jsonrpc' },
        ]
        return false
      }
      if (!('id' in data && hasOwn(data, 'id'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/id' },
        ]
        return false
      }
      if (!('method' in data && hasOwn(data, 'method'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/method' },
        ]
        return false
      }
      if (!(data.jsonrpc === '2.0')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/jsonrpc/const',
            instanceLocation: '#/jsonrpc',
          },
        ]
        return false
      }
      let passes0 = 0
      const sub0 = (() => {
        if (!(typeof data.id === 'string')) return false
        if (!format0.test(data.id)) return false
        return true
      })()
      if (sub0) passes0++
      const sub1 = (() => {
        if (!Number.isInteger(data.id)) return false
        return true
      })()
      if (sub1) passes0++
      if (passes0 !== 1) {
        validate.errors = [
          {
            keywordLocation: '#/properties/id/oneOf',
            instanceLocation: '#/id',
          },
        ]
        return false
      }
      if (!(typeof data.method === 'string')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/method/type',
            instanceLocation: '#/method',
          },
        ]
        return false
      }
      if (!pattern0.test(data.method)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/method/pattern',
            instanceLocation: '#/method',
          },
        ]
        return false
      }
      switch (data.method) {
        case 'sol_isConnected':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/0/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/0/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'sol_connect':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/1/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err0 = validate.errors
          const res0 = ref1(data.params)
          const suberr0 = ref1.errors
          validate.errors = err0
          if (!res0) {
            validate.errors = [
              errorMerge(
                suberr0[0],
                '#/oneOf/1/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'sol_signTransaction':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/2/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err3 = validate.errors
          const res3 = ref2(data.params)
          const suberr3 = ref2.errors
          validate.errors = err3
          if (!res3) {
            validate.errors = [
              errorMerge(
                suberr3[0],
                '#/oneOf/2/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'sol_signAllTransactions':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/3/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err5 = validate.errors
          const res5 = ref5(data.params)
          const suberr5 = ref5.errors
          validate.errors = err5
          if (!res5) {
            validate.errors = [
              errorMerge(
                suberr5[0],
                '#/oneOf/3/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'sol_signAndSendTransaction':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/4/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err9 = validate.errors
          const res9 = ref6(data.params)
          const suberr9 = ref6.errors
          validate.errors = err9
          if (!res9) {
            validate.errors = [
              errorMerge(
                suberr9[0],
                '#/oneOf/4/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'sol_signMessage':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/5/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err13 = validate.errors
          const res13 = ref9(data.params)
          const suberr13 = ref9.errors
          validate.errors = err13
          if (!res13) {
            validate.errors = [
              errorMerge(
                suberr13[0],
                '#/oneOf/5/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'sol_getLatestBlockhash':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/6/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err15 = validate.errors
          const res15 = ref12(data.params)
          const suberr15 = ref12.errors
          validate.errors = err15
          if (!res15) {
            validate.errors = [
              errorMerge(
                suberr15[0],
                '#/oneOf/6/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'sms_connect':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/7/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err16 = validate.errors
          const res16 = ref13(data.params)
          const suberr16 = ref13.errors
          validate.errors = err16
          if (!res16) {
            validate.errors = [
              errorMerge(
                suberr16[0],
                '#/oneOf/7/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'sms_signTransactions':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/8/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err19 = validate.errors
          const res19 = ref14(data.params)
          const suberr19 = ref14.errors
          validate.errors = err19
          if (!res19) {
            validate.errors = [
              errorMerge(
                suberr19[0],
                '#/oneOf/8/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'sms_signAndSendTransactions':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/9/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err23 = validate.errors
          const res23 = ref16(data.params)
          const suberr23 = ref16.errors
          validate.errors = err23
          if (!res23) {
            validate.errors = [
              errorMerge(
                suberr23[0],
                '#/oneOf/9/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'sms_signMessages':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/10/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err26 = validate.errors
          const res26 = ref18(data.params)
          const suberr26 = ref18.errors
          validate.errors = err26
          if (!res26) {
            validate.errors = [
              errorMerge(
                suberr26[0],
                '#/oneOf/10/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        default:
          validate.errors = [
            { keywordLocation: '#/oneOf', instanceLocation: '#' },
          ]
          return false
      }
      for (const key4 of Object.keys(data)) {
        if (
          key4 !== 'id' &&
          key4 !== 'jsonrpc' &&
          key4 !== 'method' &&
          key4 !== 'params'
        ) {
          validate.errors = [
            {
              keywordLocation: '#/unevaluatedProperties',
              instanceLocation: '#/' + pointerPart(key4),
            },
          ]
          return false
        }
      }
      return true
    }
    return ref0
  })()

  const isValid = validate(value)
  if (!isValid) {
    const { keywordLocation, instanceLocation } = validate.errors[0]
    const keyword = keywordLocation.slice(keywordLocation.lastIndexOf('/') + 1)
    const message = `JSON validation failed for ${keyword} at ${instanceLocation}`
    // TODO: Throw custom error (maybe -32700 from EIP-1474).
    throw new Error(message)
  }

  return value
}
